import { BrowserRouter } from "react-router-dom";
import MainRoutes from "./routes/main.routes";

function App() {
  return (
    <div className="w-full bg-white">
      <div className="container mx-auto bg-slate-50 shadow-lg">
        <BrowserRouter>
          <MainRoutes />
        </BrowserRouter>
      </div>
    </div>
  );
}

export default App;
